/** @jsx jsx */
import { Box, jsx } from 'theme-ui'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'

const Banner = ({ banner }) => {
  const { images, margins } = banner
  const marginSx = margins ? JSON.parse(margins.internal.content) : {}

  return (
    <Box
      mx="auto"
      sx={{
        height: '194px',
        img: {
          height: '100%',
          left: '50%',
          position: 'relative',
          transform: 'translateX(-50%) !important',
          width: 'auto',
        },
        ...marginSx,
      }}
    >
      <GatsbyImage
        image={withArtDirection(getImage(images[0]), [
          {
            image: getImage(images[3]),
            media: `(min-width: 1024px)`,
          },
          {
            image: getImage(images[2]),
            media: `(min-width: 832px)`,
          },
          {
            image: getImage(images[1]),
            media: `(min-width: 640px)`,
          },
          {
            image: getImage(images[0]),
            media: `(min-width: 0px)`,
          },
        ])}
        alt={images[0].description}
        loading={'eager'}
        style={{ height: '100%', width: 'auto' }}
      />
    </Box>
  )
}

export default Banner
